import { getAnalyticsInstance } from '../analytics'

/**
 * This is specifically for analytics tools that don't auto handle form skip events.
 * Tracks when a user skips a form section.
 *
 * @param form_section - The ID or name of the form section being skipped.
 * @param reason - Optional reason for skipping the form (e.g., user preference, not applicable).
 */
export const trackFormSkipEvent = async (form_section: string, optional_payload?: object) => {
  const analytics = getAnalyticsInstance()

  const payload = {
    form_id: form_section,
    ...optional_payload,
  }

  analytics.track('studio_form_skip', payload)
}

/**
 * This is specifically for tealium (or any other analytics tool
 * that doesn't auto handle form submit events)
 */
export const trackFormSubmitEvent = async (form_section: string, optional_payload?: object) => {
  const analytics = getAnalyticsInstance()

  const payload = {
    form_id: form_section,
    ...optional_payload,
  }

  analytics.track('form_submit', payload)
}

/**
 * This event is specifically for analytics tool that doesn't auto handle form submit errors
 *
 * @param form_section
 * @param form_error
 */
export const trackFormErrorEvent = async (form_section: string, form_error: string) => {
  const analytics = getAnalyticsInstance()

  const payload = {
    form_section,
    form_error,
  }

  analytics.track('studio_form_error', payload)
}
